import {Pipe, PipeTransform} from '@angular/core';
import {ContentPipe} from "../../../services/content/content.pipe";
import dayjs from "dayjs";

@Pipe({
    name: 'reviewDateDiff',
    standalone: true
})
export class ReviewDateDiffPipe implements PipeTransform {

    constructor(private contentPipe: ContentPipe) {
    }

    transform(reviewDate: Date | string): string {
        const date = dayjs(reviewDate).set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0);
        const now = dayjs().set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0);

        if (date.isSame(now, 'day')) {
            return this.contentPipe.transform('ai-assessments.reviewDateDialog.today');
        }

        const diffYears = date.diff(now, 'year');
        const diffMonths = date.diff(now, 'month');
        const diffDays = date.diff(now, 'day');

        if (diffYears !== 0) {
            return diffYears === 1 ? this.getTranslate('Year', diffYears) : this.getTranslate('Years', diffYears);
        } else if (diffMonths !== 0) {
            return diffMonths === 1 ? this.getTranslate('Month', diffMonths) : this.getTranslate('Months', diffMonths);
        } else {
            return diffDays === 1 ? this.getTranslate('Day', diffDays) : this.getTranslate('Days', diffDays);
        }

      }

    getTranslate(unit: string, count?: number): string {
      if (count < 0) {
          if (count === undefined) return this.contentPipe.transform(`ai-assessments.reviewDateDialog.${unit.toLowerCase()}Ago`);
          return this.contentPipe.transform(`ai-assessments.reviewDateDialog.${unit.toLowerCase()}Ago`, {params: {count: count * (-1)} });
        } else {
          if (count === undefined) return this.contentPipe.transform(`ai-assessments.reviewDateDialog.${unit}`);
          return this.contentPipe.transform(`ai-assessments.reviewDateDialog.in${unit}`, {params: {count} });
      }
    }

}
